import { z } from 'zod';

const DvrChannelEditionFormSchema = z.object({
  id: z.number().optional(),
  channel: z.number(),
  deviceId: z.number().optional(),
});

export const DvrChannelsConfigFormSchema = z
  .object({
    channels: z.array(DvrChannelEditionFormSchema),
  })
  .superRefine((data, ctx) => {
    const channels = data.channels;

    const channelSet = new Set<number>();
    channels.forEach((item, index) => {
      if (channelSet.has(item.channel)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: `Canal já registrado.`,
          path: ['channels', index, 'channel'],
        });
      } else {
        channelSet.add(item.channel);
      }
    });

    const deviceIdSet = new Set<number>();
    channels.forEach((item, index) => {
      if (item.deviceId !== undefined && item.deviceId !== null) {
        if (deviceIdSet.has(item.deviceId)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: `Dispositivo já vinculado a outro canal.`,
            path: ['channels', index, 'deviceId'],
          });
        } else {
          deviceIdSet.add(item.deviceId);
        }
      }
    });
  });

const DvrAlarmEntryEditionFormSchema = z.object({
  id: z.number().optional(),
  entry: z.number(),
  channelIds: z.array(z.number()),
});

export const DvrAlarmEntriesConfigFormSchema = z
  .object({
    alarmEntries: z.array(DvrAlarmEntryEditionFormSchema),
  })
  .superRefine((data, ctx) => {
    const alarmEntries = data.alarmEntries;

    const alarmEntriesSet = new Set<number>();
    const channelToEntryMap = new Map<number, number>();

    alarmEntries.forEach((item, index) => {
      if (alarmEntriesSet.has(item.entry)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: `Entrada de Alarme já registrada.`,
          path: ['alarmEntries', index, 'entry'],
        });
      } else {
        alarmEntriesSet.add(item.entry);
      }

      if (item.channelIds && Array.isArray(item.channelIds)) {
        const duplicatedChannels: number[] = [];
        item.channelIds.forEach((channel) => {
          if (
            channelToEntryMap.has(channel) &&
            channelToEntryMap.get(channel) !== item.entry
          ) {
            duplicatedChannels.push(channel);
          } else {
            channelToEntryMap.set(channel, item.entry);
          }
        });

        if (duplicatedChannels.length > 0) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: `Canais já vinculados a outra entrada de alarme.`,
            path: ['alarmEntries', index, 'channelIds'],
          });
        }
      }
    });
  });
